import * as Swal from "sweetalert2"

export const sweetAlert = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-success btn-lg',
        cancelButton: 'btn btn-danger btn-lg'
    },
    buttonsStyling: false
})
